import { DefaultState, TableFilters } from 'store/reducers/types';

export const READ_MY_TASKS_FILTERS_REQUEST = 'READ_MY_TASKS_FILTERS_REQUEST';
export const READ_MY_TASKS_FILTERS_SUCCESS = 'READ_MY_TASKS_FILTERS_SUCCESS';
export const READ_MY_TASKS_FILTERS_FAILURE = 'READ_MY_TASKS_FILTERS_FAILURE';

export type MyTasksFiltersState = DefaultState & {
  contents?: TableFilters;
};

interface ReadMyTasksFiltersRequest {
  type: typeof READ_MY_TASKS_FILTERS_REQUEST;
};

interface ReadMyTasksFiltersSuccess {
  type: typeof READ_MY_TASKS_FILTERS_SUCCESS,
  contents: TableFilters;
};

interface ReadMyTasksFiltersFailure {
  type: typeof READ_MY_TASKS_FILTERS_FAILURE;
};

export type MyTasksFiltersActionTypes = ReadMyTasksFiltersRequest | ReadMyTasksFiltersSuccess | ReadMyTasksFiltersFailure;